import React, { useState } from 'react'
import emailjs from 'emailjs-com'
import { init } from 'emailjs-com';
import { Container, Container as div } from 'react-bootstrap';
const Contact = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [emailSent, setEmailSent] = useState(false);
    //service_ya58pm7
    //template_crnt2oe
    //ser_UXiJs0bthtYwF0wCSkZ6R
    const submit = () => {
        if (name && email && message) {
            /* const serviceId = 'service_id';
            const templateId = 'template_id';
            const userId = 'user_id'; */
            const serviceId = 'service_ya58pm7';
            const templateId = 'template_crnt2oe';
            const userId = 'user_UXiJs0bthtYwF0wCSkZ6R';
            const templateParams = {
                name,
                email,
                message
            };

            emailjs.send(serviceId, templateId, templateParams, userId)
                .then(response => console.log(response))
                .then(error => console.log(error));

            setName('');
            setEmail('');
            setMessage('');
            setEmailSent(true);
        } else {
            alert('Please fill in all fields.');
        }
    }
    init('user_UXiJs0bthtYwF0wCSkZ6R');
    return (
        <div style={{backgroundColor:'#BC3C71',
        paddingTop:'10px'
        }} >
          <Container>
          <h3 >Please fill out the form below</h3>
            <hr/>
            <div  id="contact-form">
        <input style={{marginBottom:'5px'}} type="text" placeholder="Your Name" value={name} onChange={e => setName(e.target.value)} />
<br/>
        <input style={{marginBottom:'5px'}} type="email" placeholder="Your email address" value={email} onChange={e => setEmail(e.target.value)} />
        <br/>
        <textarea placeholder="Your message" value={message} onChange={e => setMessage(e.target.value)}></textarea>
        <br/>
        <button style={{ paddingRight:'10px'}} onClick={submit}>Send Message</button>
        <br/>
        <span className={emailSent ? 'visible'  : null }>Thank you for your message, we will be in touch with you on time!</span>
      
        
        </div>
          </Container>
        <br/><br/><br/><br/><br/><br/><br/>
        </div>
    );
};

export default Contact;
